/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import type { TextInputProps } from "$src/core/components/atoms/TextInput/types";
import CustomPlatform from "$src/core/utils/platform/platform";

export default CustomPlatform.select<() => React.FC<TextInputProps>>({
  tv: () => require("./TextInput.tv").default,
  default: () => require("./TextInput").default,
})();
